// import store from "../store";

// const subscriptionFeatures = store.getters.subscriptionData.subscriptionFeatures;

// console.log(subscriptionFeatures)

export default {
  //     id  name
  // ------  -------------------------------------------------------------------------------------------------------------
  //      1  Number of survey created per month
  //      2  Number of responses per survey per month
  //      3  Respondent Filter allowed
  //      4  Respondent Filter Limit
  //      5  Simple Analytics Visualization Allowed (Response Data presented through simple bars and chart diagram)
  //      6  Number of Questions per Survey
  //      7  Number admin allowed
  //      8  Roles for client’s admin
  //      9  Weekly or Daily Project Progress Report via Email Notifications
  //     10  Dashboard reporting allowed
  //     11  Audit Services (Use DataDash Team of Data Auditors to check and respond to Dasher's Responses in Real Time)
  //     12  Request for Advanced Analytics Allowed (not part of subscriptions)
  //     13  Chat with Team (Dashers) with Chat Box (park)
  //     14  Dasher Ranking filter allowed
  //     15  Response Download allowed
  //     16  Conditional Question allowed
  //     17  Pre-Survey
  //     18  Mobile OTP verification Allowed
  //     19  Number of Dasher Team
  //     20  Number of allowed dasher allowed in team
  //     21  Number Agent Group
  //     22  Number of agents in a group
  //     23  Project summary report download
  actionsArray: [
    {
      Preview: {
        title: "Preview",
        route_link: "/preview",
      },
      Edit: {
        title: "Edit",
        route_link: "/edit",
      },
      Live: {
        title: "Live",
        route_link: "/Live",
      },
      Schedule: {
        title: "Schedule",
        route_link: "/Schedule",
      },
      Reschedule: {
        title: "Reschedule",
        route_link: "/Reschedule",
      },
      Pause: {
        title: "Pause",
        route_link: "/Pause",
      },
      "Add Budget": {
        title: "Add Budget",
        route_link: "/Add Budget",
      },
      Resume: {
        title: "Resume",
        route_link: "/Resume",
      },
      Responses: {
        title: "Responses",
        route_link: "/Responses",
      },
      "Response Analytics": {
        title: "Response Analytics",
        route_link: "/Response_Analytics",
      },
      "Respondent Analytics": {
        title: "Respondent Analytics",
        route_link: "/Response_Analytics",
      },
      "Change Date": {
        title: "Change Date",
        route_link: "/Change Date",
      },
    },
  ],
  clientId() {
    return window.localStorage.getItem("client_id");
  },
  allowedProjectLimit(subscriptionFeatures) {
    if (this.clientId == 1) {
      return 10000;
    }
    if (subscriptionFeatures) {
      let allowedProjectLimit = subscriptionFeatures.find(
        (x) => x.service_id == 1
      );
      if (allowedProjectLimit) {
        return allowedProjectLimit.max_limit;
      }
    } else {
      return false;
    }
  },

  allowedRespondentFilter(subscriptionFeatures) {
    if (this.clientId == 1) {
      return true;
    }
    if (subscriptionFeatures) {
      let allowedRespondentFilter = subscriptionFeatures.find(
        (x) => x.service_id == 3
      );
      if (allowedRespondentFilter) {
        return true;
      }
    } else {
      return false;
    }
  },

  allowedRespondentFilterLimit(subscriptionFeatures) {
    if (this.clientId == 1) {
      return 10000;
    }
    if (subscriptionFeatures) {
      let allowedRespondentFilterLimit = subscriptionFeatures.find(
        (x) => x.service_id == 4
      );
      if (allowedRespondentFilterLimit) {
        return allowedRespondentFilterLimit.max_limit;
      }
    } else {
      return false;
    }
  },
  allowedNumberOfQuestionPerSurvey(subscriptionFeatures) {
    if (this.clientId == 1) {
      return 10000;
    }
    if (subscriptionFeatures) {
      let allowedNumberOfQuestionPerSurvey = subscriptionFeatures.find(
        (x) => x.service_id == 6
      );
      // console.log(allowedNumberOfQuestionPerSurvey);
      if (allowedNumberOfQuestionPerSurvey) {
        return allowedNumberOfQuestionPerSurvey.max_limit;
      }
    } else {
      return false;
    }
  },
  allowedNumberOfAdmin(subscriptionFeatures) {
    if (this.clientId == 1) {
      return 10000;
    }
    if (subscriptionFeatures) {
      let allowedNumberOfAdmin = subscriptionFeatures.find(
        (x) => x.service_id == 7
      );
      if (allowedNumberOfAdmin) {
        return allowedNumberOfAdmin.max_limit;
      }
    } else {
      return false;
    }
  },
  hasPreSurvey(subscriptionFeatures) {
    if (this.clientId == 1) {
      return true;
    }
    if (subscriptionFeatures) {
      let hasPreSurvey = subscriptionFeatures.find((x) => x.service_id == 17);
      if (hasPreSurvey) {
        return true;
      }
    } else {
      return false;
    }
  },
  conditionalQuestionAllowed(subscriptionFeatures) {
    if (this.clientId == 1) {
      return true;
    }
    if (subscriptionFeatures) {
      let hasMobileOTPVerification = subscriptionFeatures.find(
        (x) => x.service_id == 16
      );
      if (hasMobileOTPVerification) {
        return true;
      }
    } else {
      return false;
    }
  },
  hasMobileOTPVerification(subscriptionFeatures) {
    if (this.clientId == 1) {
      return true;
    }
    if (subscriptionFeatures) {
      let hasMobileOTPVerification = subscriptionFeatures.find(
        (x) => x.service_id == 18
      );
      if (hasMobileOTPVerification) {
        return true;
      }
    } else {
      return false;
    }
  },
  maximumNumberOfTeam(subscriptionFeatures) {
    if (this.clientId == 1) {
      return 10000;
    }
    if (subscriptionFeatures) {
      let maximumNumberOfTeam = subscriptionFeatures.find(
        (x) => x.service_id == 19
      );
      if (maximumNumberOfTeam) {
        return maximumNumberOfTeam.max_limit;
      }
    } else {
      return 0;
    }
  },
  maximumNumberOfTeamMembers(subscriptionFeatures) {
    if (this.clientId == 1) {
      return 10000;
    }
    if (subscriptionFeatures) {
      let hasMobileOTPVerification = subscriptionFeatures.find(
        (x) => x.service_id == 20
      );
      if (hasMobileOTPVerification) {
        return hasMobileOTPVerification.max_limit;
      }
    } else {
      return 0;
    }
  },
  maximumNumberOfAgentGroup(subscriptionFeatures) {
    if (this.clientId == 1) {
      return 10000;
    }
    if (subscriptionFeatures) {
      let maximumNumberOfAgentGroup = subscriptionFeatures.find(
        (x) => x.service_id == 21
      );
      if (maximumNumberOfAgentGroup) {
        return maximumNumberOfAgentGroup.max_limit;
      }
    } else {
      return 0;
    }
  },
  maximumNumberOfAgentMembers(subscriptionFeatures) {
    if (this.clientId == 1) {
      return 10000;
    }
    if (subscriptionFeatures) {
      let hasMobileOTPVerification = subscriptionFeatures.find(
        (x) => x.service_id == 22
      );
      if (hasMobileOTPVerification) {
        return hasMobileOTPVerification.max_limit;
      }
    } else {
      return false;
    }
  },
};
